module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-16.61247eed.png";